import { render, staticRenderFns } from "./MetaDataInmueble.vue?vue&type=template&id=20f637aa&"
import script from "./MetaDataInmueble.vue?vue&type=script&lang=js&"
export * from "./MetaDataInmueble.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataInmueble.vue?vue&type=style&index=0&id=20f637aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports